import clsx, { type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Helper classico shadcn/ui: concatena classi Tailwind e dedup via tailwind-merge.
 * Esempio: cn("p-4", condition && "bg-red-500", "p-6") → "bg-red-500 p-6"
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
